<template>
  <div>
    <h5 class="info-text">Dinos quien eres para dirigirnos a ti.</h5>
    <div class="md-layout">
      <div class="md-layout-item md-size-95 ml-auto mt-4 md-small-size-100">
        <md-field
          :class="[
          {'md-valid': !errors.has('firstName') && touched.firstName},
          {'md-form-group': true},
          {'md-error': errors.has('firstName')}]"
        >
          <md-icon>face</md-icon>
          <label>Nombre</label>
          <md-input
            v-model="user.firstName"
            data-vv-name="firstName"
            type="text"
            name="firstName"
            required
            v-validate="modelValidations.firstName"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('firstName')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('firstName') && touched.firstName">done</md-icon>
          </slide-y-down-transition>
        </md-field>

        <md-field
          :class="[
          {'md-valid': !errors.has('phone') && touched.phone},
          {'md-form-group': true},
          {'md-error': errors.has('phone')}]"
        >
          <md-icon>phone</md-icon>
          <label>Telefono</label>
          <md-input
            v-model="user.phone"
            data-vv-name="phone"
            type="text"
            name="phone"
            required
            v-validate="modelValidations.phone"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('phone')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('phone') && touched.lastName">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-95 ml-auto mt-4 md-small-size-100">
        <md-field
          :class="[
          {'md-valid': !errors.has('email') && touched.email},
          {'md-form-group': true},
          {'md-error': errors.has('email')}]"
        >
          <md-icon>email</md-icon>
          <label>Email</label>
          <md-input
            v-model="user.email"
            data-vv-name="email"
            type="text"
            name="email"
            required
            v-validate="modelValidations.email"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('email')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('email') && touched.email">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { apiServer, staticServer } from "@/globalVars.js";

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      image: "",
      single: null,
      firstName: "",
      lastName: "",
      email: "",
      touched: {
        firstName: false,
        phone: false,
        email: false
      },
      modelValidations: {
        firstName: {
          required: true,
          min: 2
        },
        phone: {
          required: true,
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res);

        return res;
      });
    }
  },
  watch: {
    firstName() {
      this.touched.firstName = true;
    },
    phone() {
      this.touched.lastName = true;
    },
    email() {
      this.touched.email = true;
    }
  }
};
</script>
<style>
</style>
